<template src="./index.html"></template>
<script>
import { getdata } from './data.js';
import {
    pageinfo,
    checkQc,
    startQc,
    checkSj,
    startSj,
    getTaskList,
    checkShenBStatus,
    initShenBStatus,
    queryMustQcAndQsShuib,
    batchStartQc, batchStartSj, batchInitShenBStatus
} from '../../../../../src/api/qcsj.js';
import { deleteBatchAutoLog, downloadPdf, loginInfo, queryGatewayInfo } from '@/api/organization';
import { syncInvoiceInfo } from '@/api/xxzzs';
import { kydkpz_queryCompanyList } from '@/api/kydkpz';
import bsdl from '@/components/common/bsdl/index.vue';
export default {
	name: 'qcsj',
	components: { bsdl },
	data: function() {
		return {
			tablekey: 0,
			searchdata: getdata().searchdata,
			searchlist: getdata().searchlist,
			outlist: [],
			headData: getdata().headData,
			pagination: getdata().pagination,
			tableData: [{}, {}],
			shaidiag: false,
			searchdiag: false,
			Rwdiag: false,
			radio2: null,
            step: '0',
            drawer:false,
            dialogFormVisible: false,
            syncForm: getdata().syncFormDefault,
            formLabelWidth: '120px',
            options:[],
            logId: 0,
            rpaFormData: {},
            invoiceStatus: [
                {
                    label: "全部",
                    value: "ALL"
                },
                {
                    label: "正常",
                    value: "NORMAL"
                },
                {
                    label: "已作废",
                    value: "VOID"
                },
                {
                    label: "部分红冲",
                    value: "PARTIAL_RED"
                },
                {
                    label: "全额红冲",
                    value: "FULL_RED"
                }
            ],
			RWData: [],
			suosq: this.$getdefultMonth(),
			initList:[],//税种下拉列表
			shuizType:'',//税种下拉所选择的id
		};
	},
	mounted() {},
	created() {
		this.init()//获取税种下拉数据
		this.page()
	},
	methods: {
        closedialog() {
            this.dialogFormVisible = false;
            this.syncForm = getdata().syncFormDefault
            this.step = 0;
        },
        smsClose() {
            this.drawer = false;
        },
		tableRowClassName(e) {
			if (e.row.id==this.radio2) {
				return 'searchnow_Row'
			}
		},
        submitSync() {
            if (!this.syncForm.issueDate || this.syncForm.issueDate.length === 0) {
                this.$message.error("请选择开票日期")
                return;
            }/*
          if (!this.syncForm.invoiceType) {
              this.$message.error("请选择发票类型")
              return;
          }*/
            if (!this.syncForm.companyId) {
                this.$message.error("请选择同步企业")
                return;
            }
            if (!this.syncForm.invoiceStatus && (this.step === '6' || this.step === '66')) {
                this.$message.error("请选择发票状态")
                return;
            }
            this.syncForm.issueStart = this.syncForm.issueDate[0];
            this.syncForm.issueEnd = this.syncForm.issueDate[1];
            if (this.step === '66') {
                this.syncForm.invoiceType = "INPUT";
                this.syncForm.step = 6; // 当前步骤
            } else {
                this.syncForm.invoiceType = "OUTPUT";
                this.syncForm.step = this.step; // 当前步骤
            }
            let companyId = this.syncForm.companyId;
            syncInvoiceInfo(this.syncForm).then(res => {
                if (res.data.code === "1"){
                    this.$message.success("已提交同步任务，请稍后再进行查询")
                } else if (res.data.code === "102") {
                    // 需要登录
                    this.$confirm('同步失败，RPA未登录，点击确认进行登录', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        queryGatewayInfo({companyId: companyId}).then(gatewayRes => {
                            if (gatewayRes.data.code === 1) {
                                this.logId = res.data.data;
                                this.rpaFormData = gatewayRes.data.data[0];
                                this.drawer = true;
                            }
                        })
                    }).catch(()=>{
                        deleteBatchAutoLog({id: res.data.data}).then(autoLogRes=>{})
                    });
                } else {
                    this.$message.error("提交任务失败，原因：" + res.data.msg);
                }
                this.closedialog();
            })
        },
		init(){
			queryMustQcAndQsShuib().then(res=>{
				if(res.data.code==1){
						this.initList = res.data.data //赋值
						this.shuizType = res.data.data[0].type //默认值 选择第一个
				}else{
					this.$message.error(res.data.msg)
				}
			})
            kydkpz_queryCompanyList().then(res => {
                if (res.data.code === 1) {
                    let _data = res.data.data.map(v => {
                        return {
                            value: v.id,
                            label: v.nsrmc
                        };
                    });
                    this.options.push(..._data);
                } else {
                    this.$message.error(res.data.msg);
                }
            });
		},
		StatusS(){
            let idArr = this.getSelectionval();
            if (idArr.length === 0) {
                this.$message.warning('请先选择您要税局状态同步的公司');
                return;
            }
			if(idArr.length === 1){
				let params = {
					companyId: idArr[0],
					ssq:this.suosq,
				}
				checkShenBStatus(params).then(res=>{
					 if(res.data.code==1){
							initShenBStatus(params).then(res=>{
								 if(res.data.code==1){
									this.page()
									this.$message.success('税局状态同步成功')
								}else{
									this.$message.error(res.data.msg)
								}
							})
					}else{
						this.$showConfirm({
							message: res.data.msg
						}).then(res => {
							if (res == "confirm") {
								initShenBStatus(params).then(res=>{
									 if(res.data.code==1){
										this.page()
										this.$message.success('税局状态同步成功')
									}else{
										this.$message.error(res.data.msg)
									}
								})							  //确认
							}
						})
					}
				})
			} else {
                let params = {
                    companyId: idArr.join(","),
                    ssq:this.suosq,
                }
                batchInitShenBStatus(params).then(res=>{
                    if(res.data.code==1){
                        this.page()
                        this.$message.success('税局状态同步成功')
                    }else{
                        this.$message.error(res.data.msg)
                    }
                })
            }
		},
		clickitem(e) {
			e === this.radio2 ? (this.radio2 = '') : (this.radio2 = e);
		},
        //获取清册
		hqqc() {
            let idArr = this.getSelectionval();
            if (idArr.length === 0) {
                this.$message.warning('请先选择您要清册的公司');
                return;
            }
            //获取清册
            if (idArr.length == 1) {
                let params = { companyId: idArr[0], shuizType:this.shuizType };
                checkQc(params).then(res => {
                    //清册校验
                    if (res.data.code == 1) {
                        //清册校验成功后调用清册
                        startQc(params).then(res => {
                            if (res.data.code == 1) {
                                this.$message.success('清册成功');
                                this.page();
                            } else {
                                this.$message.error(res.data.msg);
                            }
                        });
                    } else {
                        this.$showConfirm({
                            message: res.data.msg
                        }).then(res => {
                            if (res == "confirm") {
                                startQc(params).then(res => {
                                    if (res.data.code == 1) {
                                        this.$message.success('清册成功');
                                        this.page();
                                    } else {
                                        this.$message.error(res.data.msg);
                                    }
                                });									  //确认
                            }
                        })
                    }
                });
            } else {
                //批量清册
                let params = { companyIds: idArr.join(","), shuizType:this.shuizType };
                batchStartQc(params).then(res => {
                    if (res.data.code == 1) {
                        this.$message.success('清册成功');
                        this.page();
                    } else {
                        this.$message.error(res.data.msg);
                    }
                });
            }

		},
		page() {
			let params = {
				current: this.pagination.pageNum,
				size: this.pagination.pageSize,
				...this.searchdata
			};
			pageinfo(params).then(res => {
				if (res.data.code == 1) {
					this.tableData  = res.data.data.records
					this.pagination.total = res.data.data.total
				} else {
					this.$message.error(res.data.msg);
				}
			});
		},
		sizechange(e) {
			this.pagination.pageSize = e;
			this.page();
		},
		currentChange(e) {
			this.pagination.pageNum = e;
			this.page();
		},
		submitSearch() {
			this.pagination.pageNum = 1;
			this.pagination.paginationkey++;
			this.page();
		},
		forRefresh() {
			this.pagination.pageNum = 1;
			this.pagination.paginationkey++;
			this.page();
		},

		forUpdateSearch() {
			this.searchdiag = true;
		},
		closeSearch() {
			this.searchdiag = false;
		},
		saveChange(e) {
			this.searchdiag = false;
		},
		confirmfilter(e) {
			this.headData = e.chooselist;
			this.outlist = e.nochooselist;
			this.shaidiag = false;
		},
        handleCommand(command) {
            if (command !== "99") {
                this.step = command;
                this.dialogFormVisible = true;
            } else {
                this.$showConfirm({
                    message: "温馨提示：该任务将执行【当前属期已申报完成】的进行pdf和完税凭证下载，确认后开始执行请求",
                }).then((result) => {
                    if (result === "confirm") {
                        downloadPdf().then(res => {
                            if (res.data.code === "1") {
                                this.$message.info("发起成功，请等待定时任务执行返回");
                            } else {
                                this.$message.error("发起失败："+res.data.msg);
                            }
                        })
                    }
                })

            }
        },
		closeshaidiag() {
			this.shaidiag = false;
		},
        //税局取数
		forqushu() {
            let idArr = this.getSelectionval();
            if (idArr.length === 0) {
                this.$message.warning('请先选择您要税局取数的公司');
                return;
            }
			this.$showConfirm({
				message: '初始化只支持增值税、企业所得税、财务报表、工会经费这四个税种的初始化，并将覆盖您申报表已填写的相关数据，重新生成申报表。请确认是否继续？?'
			}).then(res => {
				if (res == 'confirm') {
                    if (idArr.length == 1) {
                        // 查询当前企业勾选的通道
                        let tunnelParams = {
                            companyId: idArr[0]
                        };
                        loginInfo(tunnelParams).then(res => {
                            let params = {
                                companyId: idArr[0],
                                shuizType:this.shuizType,
                                tunnelType:res.data.data.companyLoginInfo.sbtd
                            }
                            if (res.data.code === 1) {
                                // 请求成功
                                if (res.data.data.companyLoginInfo && res.data.data.companyLoginInfo.sbtd === "RPA") {
                                    this.sjqs(params);
                                } else {
                                    checkSj(params).then(res=>{
                                        if(res.data.code==1){
                                            this.sjqs(params);
                                        }else{
                                            this.$message.error(res.data.msg)
                                        }
                                    })
                                }
                            } else {
                                // 请求失败, 走旧逻辑需要进项清册校验
                                checkSj(params).then(res=>{
                                    if(res.data.code==1){
                                        this.sjqs(params);
                                    }else{
                                        this.$message.error(res.data.msg)
                                    }
                                })
                            }
                        })

                    } else {
                        //批量取数
                        let params = {
                            companyIds: idArr.join(","),
                            shuizType:this.shuizType
                        }
                        batchStartSj(params).then(res=>{
                            if(res.data.code==1){
                                this.page()
                                this.$message.success('税局取数成功')
                            }else{
                                this.$message.error(res.data.msg)
                            }
                        })
                    }

                }
			});
		},
        sjqs(params) {
            startSj(params).then(res=>{
                if(res.data.code==1){
                    this.page()
                    this.$message.success('税局取数成功')
                }else if (res.data.code === "102") {
                    // 需要登录

                    let idArr = this.getSelectionval();
                    this.$confirm('同步失败，RPA未登录，点击确认进行登录', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消', 
                        type: 'warning'
                    }).then(() => {
                        queryGatewayInfo({companyId: idArr[0]}).then(gatewayRes => {
                            if (gatewayRes.data.code === 1) {
                                this.logId = res.data.data;
                                this.rpaFormData = gatewayRes.data.data[0];
                                this.drawer = true;
                            }
                        })
                    }).catch(()=>{
                        deleteBatchAutoLog({id: res.data.data}).then(autoLogRes=>{})
                    });
                }else{
                    this.$message.error(res.data.msg)
                }
            })

        },
        formatStep(step) {
            switch (step) {
                case 2:
                    return "获取清册";
                case 3:
                    return "税局取数";
                case 66:
                    return "进项发票数据同步";
                case 6:
                    return "销项发票数据同步";
                case 7:
                    return "进项抵扣数据同步";
                case 8:
                    return "代扣代缴数据同步";
                case 9:
                    return "海关缴款书数据同步";
            }
        },
		forseeRw(e) {
			let params = {
				companyId:e
			}
			getTaskList(params).then(res=>{
				 if(res.data.code==1){
					 this.RWData = []
					 res.data.data.map((item,index)=>{
						 this.RWData.push({
							 title:item.step,
							 typeDesc:item.shuizMc,
							 RWlist:[{
								 text:item.faq,
								 timetxt:item.faqTime,
							 },{
								 text:item.executionDesc,
								 timetxt:item.updateTime,
								 type:item.executionStatus==4?'fail':''
							 },{
								 text:item.taskDesc ? item.taskDesc : (item.status===2 ? "" :"执行成功"),
								 type:item.status==2?'fail':''
							 }]
						 })
					 })
					this.Rwdiag = true;
					this.page()
				}else{
					this.$message.error(res.data.msg)
				}
			})
		},

        getSelectionval(){
            let selectData = this.$refs.qcsjtablebox.getSelectionval()
            let ids = [];
            if (selectData.length > 0) {
                ids = selectData.map((item,index)=> item.id);
            }
            return ids;
        },
	}
};
</script>

<style scoped lang="less">
@import url('./index.less');
</style>
